import { type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import DataService from "features/Application/services/dataServices/typedDataService";
import { fetchBegin, fetchFailure, fetchSuccess } from "../EmbeddedVideoDetailsSlice";
import { openEntityDetails, setEntityId } from "../EmbeddedVideosEntityStateSlice";

export const fetchEmbeddedVideo =
  (id: number): AppThunk =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(fetchBegin());
      const response = await DataService.embeddedVideos.getEmbeddedVideo(id);
      const embeddedVideo = response.data;
      dispatch(fetchSuccess(embeddedVideo));
      dispatch(
        openEntityDetails({
          id: embeddedVideo.id,
          isDraft: embeddedVideo.isDraft,
          dateModified: embeddedVideo.dateModified,
        }),
      );
      dispatch(setEntityId(id));
    } catch (_) {
      dispatch(fetchFailure());
    }
  };
